import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { withRouter } from '../../../util/withRouter';
import { Dropdown, DropdownButton, Form, Button } from 'react-bootstrap';
import CheckBox from '../../../components/Checkbox/Checkbox';

import { getDashboards, exportCsv } from '../DashboardsActions';
import { getAllowedDashboards } from '../../../util/dashboardPermissions';

import pagination from '../../../util/pagination';
import throttle from '../../../util/throttle';

import Loading from '../../../components/Loading/Loading';
import ProgressDashboard from '../../../components/ProgressDashboard/ProgressDashboard';

import arrowSortIcon from '../../../assets/img/arrow-down.svg';
import editIcon from '../../../assets/img/edit.svg';

// Import Style
import './DashboardAcivities.scss';

export class DashboardActivities extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      filter: 'all',
      sort: '-createdDate',
      search: '',
      page: 1,
      boards: [],
      sortName: [
        {
          name: 'Name: A to Z',
          value: 'name'
        },
        {
          name: 'Name: Z to A',
          value: '-name'
        }
      ],
      sortCreatedDate: [
        {
          name: 'Created date: newest first',
          value: '-createdDate'
        },
        {
          name: 'Created date: oldest first',
          value: 'createdDate'
        }
      ],
      sortUpdatedDate: [
        {
          name: 'Updated date: newest first',
          value: '-updatedDate'
        },
        {
          name: 'Updated date: oldest first',
          value: 'updatedDate'
        }
      ],
      sortAccessedDate: [
        {
          name: 'Accessed date: newest first',
          value: '-accessedDate'
        },
        {
          name: 'Accessed date: oldest first',
          value: 'accessedDate'
        }
      ]
    };

    this.getDashboardsThrottled = throttle(this.getDashboards, 500, this);
    this.exportCsvThrottled = throttle(this.exportCsv, 500, this);
  }

  componentDidMount() {
    this.getDashboards();
  }

  applySort = sort => {
    this.setState({ sort, page: 1 }, this.getDashboards);
  };

  getDashboards = () => {
    const { search, sort, page } = this.state;
    const { userId : id } = this.props;
    
    this.props.getDashboards({ search, sort, page, id });
  };

  onSearch = e => {
    this.setState({ search: e.target.value, page: 1 }, this.getDashboardsThrottled);
  };

  goto = page => {
    if (page < 1) {
      page = 1;
    }

    this.setState({ page }, this.getDashboards);
  };

  renderSelected = type => {
    const selected = _.find(this.state[type + 'Options'], {
      value: this.state[type]
    });
    return selected ? selected.name : '';
  };

  toggleFilter = () => {
    document.getElementById('filter-content').classList.toggle('shown');
  };

  handleClick = id => {
    this.props.router.push(`/permissions/${id}`);
  };

  exportCsv = () => {
    const { filter, sort, search } = this.state;
    this.props.exportCsv({ filter, sort, search, page: 'all' });
  };

  handleExport = ev => {
    ev.preventDefault();
    ev.stopPropagation();
    ev.target.blur();
    this.exportCsvThrottled();
  };

  renderPagination = () => {
    const pages = pagination(this.props.total, this.props.page, 20, 5);

    if (pages.totalPages < 2) {
      return <div></div>;
    }

    return (
      <ul className="pagination">
        {pages.currentPage > 1 && (
          <li aria-label="First" onClick={() => this.goto(1)}>
            <a role="button" href="#">
              «
            </a>
          </li>
        )}
        {pages.currentPage > 1 && (
          <li aria-label="Prev" onClick={() => this.goto(pages.currentPage - 1)}>
            <a role="button" href="#">
              ‹
            </a>
          </li>
        )}
        {pages.pages.map((p, i) => {
          return (
            <li className={p === pages.currentPage && 'active'} key={i} onClick={() => this.goto(p)}>
              <a role="button" href="#">
                {p}
              </a>
            </li>
          );
        })}
        {pages.currentPage < pages.totalPages && (
          <li aria-label="Next" onClick={() => this.goto(pages.currentPage + 1)}>
            <a role="button" href="#">
              ›
            </a>
          </li>
        )}
        {pages.currentPage < pages.totalPages && (
          <li aria-label="Last" onClick={() => this.goto(pages.totalPages)}>
            <a role="button" href="#">
              »
            </a>
          </li>
        )}
      </ul>
    );
  };

  renderProgressDashboard(user) {
    if (user && user.allowedDashboards) {
      return (
        <div className="progress-box">
          <label>Dashboards in use: </label>
          <ProgressDashboard limitNumber={user.allowedDashboards} usedNumber={user.dashboards} />
        </div>
      );
    }
  }

  renderDashboardLabel = (d) => {
    return (!d.label || d.label == d.name) ?
      (<p>{d.name}</p>) : 
      (
        <React.Fragment>
          <p>{d.label}</p>
          <p>{d.name}</p>
        </React.Fragment>
      );
  }

  render() {
    const { dashboards, isLoading, user } = this.props;
    const hasUserInfo = _.some(dashboards, dashboard => 
      !_.isEmpty(dashboard.createdBy) || !_.isEmpty(dashboard.updatedBy)
    );
    const allowedDashboards = getAllowedDashboards(dashboards, user);
    const title = this.props.selectable? "Select dashboards": "Dashboards activity";
    return (
      <React.Fragment>
        <div className={`table-content${this.props.actions ? ' table-card' : ''}`}>
          <div className="table-filter">
            <h5>{title}</h5>
            <div className="u-di">
              <div className="search-wrap">
                <input
                  name="search"
                  placeholder="Search"
                  type="text"
                  id="Search"
                  className="form-control"
                  value={this.state.search}
                  onChange={this.onSearch}
                />
              </div>
            </div>
            {/*<div className='filter-button' onClick={this.toggleFilter}>
                  <img alt="filter" src={filterImage} />
                </div>*/}
          </div>
          <div className="table-scroll">
            <table className="table">
              <thead>
                <tr>                 
                  <th>
                    <div className="flex">
                      Dashboard name
                      <Form.Group controlId="sort" className="filter-dropdown">
                        <DropdownButton
                          className="form-control-dropdown-sort"
                          id="dropdown-item-button"
                          title={<img src={arrowSortIcon} alt="#" />}
                        >
                          {this.state.sortName.map((s, i) => {
                            return (
                              <Dropdown.Item
                                key={i}
                                as="button"
                                className={this.state.sort === s.value && 'active'}
                                onClick={() => this.applySort(s.value)}
                              >
                                {s.name}
                              </Dropdown.Item>
                            );
                          })}
                        </DropdownButton>
                      </Form.Group>
                    </div>
                  </th>
                  <th>
                    <div className="flex">
                      { hasUserInfo ? 'Created by':'Created'}
                      <Form.Group controlId="sort" className="filter-dropdown">
                        <DropdownButton
                          className="form-control-dropdown-sort"
                          id="dropdown-item-button"
                          title={<img src={arrowSortIcon} alt="#" />}
                        >
                          {this.state.sortCreatedDate.map((s, i) => {
                            return (
                              <Dropdown.Item
                                key={i}
                                as="button"
                                className={this.state.sort === s.value && 'active'}
                                onClick={() => this.applySort(s.value)}
                              >
                                {s.name}
                              </Dropdown.Item>
                            );
                          })}
                        </DropdownButton>
                      </Form.Group>
                    </div>
                  </th>
                  <th>
                    <div className="flex">
                      { hasUserInfo ? 'Updated by':'Updated'}
                      <Form.Group controlId="sort" className="filter-dropdown">
                        <DropdownButton
                          className="form-control-dropdown-sort"
                          id="dropdown-item-button"
                          title={<img src={arrowSortIcon} alt="#" />}
                        >
                          {this.state.sortUpdatedDate.map((s, i) => {
                            return (
                              <Dropdown.Item
                                key={i}
                                as="button"
                                className={this.state.sort === s.value && 'active'}
                                onClick={() => this.applySort(s.value)}
                              >
                                {s.name}
                              </Dropdown.Item>
                            );
                          })}
                        </DropdownButton>
                      </Form.Group>
                    </div>
                  </th>
                  <th>
                    <div className="flex">
                      {hasUserInfo ? 'Last accessed by':'Last accessed'}
                      <Form.Group controlId="sort" className="filter-dropdown">
                        <DropdownButton
                          className="form-control-dropdown-sort"
                          id="dropdown-item-button"
                          title={<img src={arrowSortIcon} alt="#" />}
                        >
                          {this.state.sortAccessedDate.map((s, i) => {
                            return (
                              <Dropdown.Item
                                key={i}
                                as="button"
                                className={this.state.sort === s.value && 'active'}
                                onClick={() => this.applySort(s.value)}
                              >
                                {s.name}
                              </Dropdown.Item>
                            );
                          })}
                        </DropdownButton>
                      </Form.Group>
                    </div>
                  </th>
                  {this.props.actions && (<th className="width-auto">Action</th>)}
                </tr>
              </thead>
              <tbody>
                {allowedDashboards.map((d, i) => {
                  return (
                    <tr key={i}>                      
                      <td>
                        {this.props.selectable ? (                        
                            <CheckBox
                                id={d._id}
                                name={d._id}
                                label={this.renderDashboardLabel(d)}
                                onChange={this.props.handleChange}
                                checked={this.props.selected.indexOf(d._id) > -1}
                              />
                        )
                        : this.renderDashboardLabel(d)}
                      </td>
                      <td>
                        {d.createdBy ? (
                          <React.Fragment>
                            <p>{d.createdBy.name}</p>
                            <p>{d.createdBy.email}</p>
                            <p>{d.createdAt ? moment(d.createdAt).format('D MMM YYYY hh:mm A') : '-'}</p>
                          </React.Fragment>
                        ) : (
                          <p>{d.createdAt ? moment(d.createdAt).format('D MMM YYYY hh:mm A') : '-'}</p>
                        )}
                      </td>
                      <td>
                        {d.updatedBy ? (
                          <React.Fragment>
                            <p>{d.updatedBy.name}</p>
                            <p>{d.updatedBy.email}</p>
                            <p>{d.modifiedAt ? moment(d.modifiedAt).format('D MMM YYYY hh:mm A') : '-'}</p>
                          </React.Fragment>
                        ) : (
                          <p>{d.modifiedAt ? moment(d.modifiedAt).format('D MMM YYYY hh:mm A') : '-'}</p>
                        )}
                      </td>
                      <td>
                        {d.accessedBy ? (
                          <React.Fragment>
                            <p>{d.accessedBy.name}</p>
                            <p>{d.accessedBy.email}</p>
                            <p>{d.accessedAt ? moment(d.accessedAt).format('D MMM YYYY hh:mm A') : '-'}</p>
                          </React.Fragment>
                        ) : (
                          <p>{d.accessedAt ? moment(d.accessedAt).format('D MMM YYYY hh:mm A') : '-'}</p>
                        )}
                      </td>
                      {this.props.actions && (
                         <td className="width-auto">                     
                          <Button
                            variant="secondary"
                            size="md"
                            className="btn-mw-180"
                            onClick={() => this.handleClick(d._id)}
                          >
                            <img src={editIcon} alt="" />
                            Edit permissions
                          </Button>                        
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        <div className="action-footer">
          {this.renderProgressDashboard(user)}
          {this.renderPagination()}
        </div>

        {isLoading && (
          <div className="table-loading">
            <Loading />
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    exportCsv: opt => dispatch(exportCsv(opt)),
    getDashboards: opt => dispatch(getDashboards(opt))
  };
};

const mapStateToProps = state => {
  return {
    dashboards: state.boards.boards,
    isLoading: state.boards.loading,
    page: state.boards.page,
    total: state.boards.total,
    user: state.auth.user
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DashboardActivities));
